module.exports = __webpack_public_path__ + "img/device-tablet.902f31d0.svg";